/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Rule_No_MultiplyInputs */

const en_us2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps do not multiply the weight: 10 kg for 10 reps is not 100 kg.`)
};

const pt_br2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As repetições não multiplicam o peso: 10 kg em 10 repetições não vira 100 kg.`)
};

const es_419_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las repeticiones no multiplican el peso: 10 kg en 10 repeticiones no son 100 kg.`)
};

const pt_pt2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As repetições não multiplicam o peso: 10 kg em 10 repetições não são 100 kg.`)
};

const fr_fr2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les répétitions ne multiplient pas la charge : 10 kg sur 10 répétitions, ce n'est pas 100 kg.`)
};

const de_de2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungen multiplizieren das Gewicht nicht: 10 kg mal 10 Wiederholungen sind nicht 100 kg.`)
};

const it_it2_exercise_personal_info_rule_no_multiply = /** @type {(inputs: Exercise_Personal_Info_Rule_No_MultiplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le ripetizioni non moltiplicano il peso: 10 kg per 10 ripetizioni non fanno 100 kg.`)
};

/**
* | output |
* | --- |
* | "Reps do not multiply the weight: 10 kg for 10 reps is not 100 kg." |
*
* @param {Exercise_Personal_Info_Rule_No_MultiplyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_rule_no_multiply = /** @type {((inputs?: Exercise_Personal_Info_Rule_No_MultiplyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Rule_No_MultiplyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_rule_no_multiply(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_rule_no_multiply(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_rule_no_multiply(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_rule_no_multiply(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_rule_no_multiply(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_rule_no_multiply(inputs)
	return en_us2_exercise_personal_info_rule_no_multiply(inputs)
});
export { exercise_personal_info_rule_no_multiply as "exercise-personal.info_rule_no_multiply" }